"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Delete_1 = tslib_1.__importDefault(require("@mui/icons-material/Delete"));
const Edit_1 = tslib_1.__importDefault(require("@mui/icons-material/Edit"));
const MoreVert_1 = tslib_1.__importDefault(require("@mui/icons-material/MoreVert"));
const Visibility_1 = tslib_1.__importDefault(require("@mui/icons-material/Visibility"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const ListItemIcon_1 = tslib_1.__importDefault(require("@mui/material/ListItemIcon"));
const ListItemText_1 = tslib_1.__importDefault(require("@mui/material/ListItemText"));
const Menu_1 = tslib_1.__importDefault(require("@mui/material/Menu"));
const MenuItem_1 = tslib_1.__importDefault(require("@mui/material/MenuItem"));
const TableCell_1 = tslib_1.__importDefault(require("@mui/material/TableCell"));
/**
 *
 * @category component
 */
const MenuButtonIcon = ({ icon, ...rest }) => {
    switch (icon) {
        case "edit":
            return react_1.default.createElement(Edit_1.default, { "aria-label": "edit", ...rest });
        case "delete":
            return react_1.default.createElement(Delete_1.default, { "aria-label": "delete", ...rest });
        case "view":
            return react_1.default.createElement(Visibility_1.default, { "aria-label": "delete", ...rest });
        default:
            throw Error(`${icon} not supported in MenuButtonIcon`);
    }
};
/**
 *
 * @category component
 */
const MenuButtonCell = ({ columnId, items, MenuProps = {}, ...rest }) => {
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (react_1.default.createElement(TableCell_1.default, { ...rest },
        react_1.default.createElement(IconButton_1.default, { "aria-label": "row-menu", "aria-controls": "row-menu", "aria-haspopup": "true", onClick: handleClick },
            react_1.default.createElement(MoreVert_1.default, null)),
        react_1.default.createElement(Menu_1.default, { ...MenuProps, anchorEl: anchorEl, open: open, onClose: handleClose }, items.map(({ onClick, icon, label, MenuItemProps = {} }, idx) => {
            return (react_1.default.createElement(MenuItem_1.default, { ...MenuItemProps, key: idx, onClick: () => {
                    onClick();
                    handleClose();
                } },
                icon && (react_1.default.createElement(ListItemIcon_1.default, null,
                    react_1.default.createElement(MenuButtonIcon, { icon: icon }))),
                label && react_1.default.createElement(ListItemText_1.default, { primary: label })));
        }))));
};
exports.default = MenuButtonCell;
